// src/canvas/board/types.ts
var CanvasBoardAriResourceOwner = "canvas", CanvasBoardAriResourceType = "board";

export {
  CanvasBoardAriResourceOwner,
  CanvasBoardAriResourceType
};
